module.exports = {
	"id": "AO",
	"name": "Angola",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.048895,
			"12": 0.01778,
			"13": 0.004445,
			"14": null,
			"15": 0.004445,
			"16": null,
			"17": null,
			"18": 0.00889,
			"19": null,
			"20": 0.013335,
			"21": 0.013335,
			"22": 0.01778,
			"23": 0.03556,
			"24": 0.00889,
			"25": 0.01778,
			"26": 0.04445,
			"27": 0.022225,
			"28": 0.00889,
			"29": 0.05334,
			"30": 0.00889,
			"31": 0.02667,
			"32": 0.01778,
			"33": 0.048895,
			"34": 0.01778,
			"35": 0.022225,
			"36": 1.400175,
			"37": 0.00889,
			"38": 0.022225,
			"39": 0.01778,
			"40": 0.05334,
			"41": 0.022225,
			"42": 0.03556,
			"43": 0.946785,
			"44": 0.02667,
			"45": 0.22225,
			"46": 0.04445,
			"47": 0.1778,
			"48": 0.031115,
			"49": 0.626745,
			"50": 0.164465,
			"51": 0.591185,
			"52": 0.475615,
			"53": 15.313025,
			"54": 3.85826,
			"55": 0.084455,
			"56": 0.013335,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.013335,
			"4": 0.01778,
			"5": 0.02667,
			"6": 0.00889,
			"7": 0.00889,
			"8": 0.004445,
			"9": 0.00889,
			"10": 0.013335,
			"11": 0.02667,
			"12": 0.031115,
			"13": 0.022225,
			"14": 0.03556,
			"15": 0.01778,
			"16": 0.022225,
			"17": 0.022225,
			"18": 0.004445,
			"19": 0.013335,
			"20": 0.01778,
			"21": 0.022225,
			"22": 0.031115,
			"23": 0.031115,
			"24": 0.013335,
			"25": 0.031115,
			"26": 0.03556,
			"27": 0.00889,
			"28": 0.004445,
			"29": 0.013335,
			"30": 0.084455,
			"31": 0.01778,
			"32": 0.013335,
			"33": 0.13335,
			"34": 0.00889,
			"35": 0.01778,
			"36": 0.013335,
			"37": 0.04445,
			"38": 0.02667,
			"39": 0.01778,
			"40": 0.031115,
			"41": 0.022225,
			"42": 0.022225,
			"43": 0.173355,
			"44": 0.057785,
			"45": 0.075565,
			"46": 0.07112,
			"47": 0.49784,
			"48": 0.555625,
			"49": 3.52044,
			"50": 0.06223,
			"51": 0.004445,
			"52": null,
			"3.5": 0.00889,
			"3.6": 0.048895
		},
		"opera": {
			"9": null,
			"11": 0.004445,
			"12": 0.013335,
			"15": 0.00889,
			"16": 0.004445,
			"17": null,
			"18": 0.00889,
			"19": null,
			"20": 0.00889,
			"21": 0.004445,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.00889,
			"29": 0.00889,
			"30": 0.004445,
			"31": 0.004445,
			"32": null,
			"33": 0.00889,
			"34": 0.022225,
			"35": 0.02667,
			"36": 0.02667,
			"37": 0.084455,
			"38": 0.022225,
			"39": 0.09779,
			"40": 0.67564,
			"41": 0.10668,
			"42": null,
			"43": null,
			"9.5-9.6": 0.00889,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.013335,
			"11.1": null,
			"11.5": 0.00889,
			"11.6": 0.022225,
			"12.1": 0.040005
		},
		"safari": {
			"0": null,
			"4": 0.013335,
			"5": 0.022225,
			"6": 0.00889,
			"7": 0.01778,
			"8": 0.137795,
			"9": 0.16002,
			"10": 0.937895,
			"3.1": null,
			"3.2": null,
			"5.1": 0.04445,
			"6.1": 0.03556,
			"7.1": 0.013335,
			"9.1": 0.67564
		},
		"ios_saf": {
			"8": 0,
			"10": 2.46070311407,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.066313101582,
			"8.1-8.4": 0.122510645296,
			"9.0-9.2": 0.0584454454621,
			"9.3": 0.891667693589
		},
		"android": {
			"3": 0,
			"4": 0.118363126615,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0147953908269,
			"4.1": 0.426952706718,
			"4.2-4.3": 1.0673817668,
			"4.4": 2.44758036822,
			"4.4.3-4.4.4": 2.46871664083
		},
		"ie": {
			"6": null,
			"7": 0.0134702826087,
			"8": 0.561261775362,
			"9": 0.363697630435,
			"10": 0.543301398551,
			"11": 4.71459891304,
			"5.5": null
		},
		"op_mob": {
			"0": 1.90317867155,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0528660742098
		},
		"edge": {
			"12": 0.27559,
			"13": 0.653415,
			"14": 1.12903
		},
		"ie_mob": {
			"10": 0.119393380282,
			"11": 0.486101619718
		},
		"bb": {
			"7": 0.04027375,
			"10": null
		},
		"samsung": {
			"0": 2.660845
		},
		"and_uc": {
			"0": 1.42208
		},
		"op_mini": {
			"0": 25.6411952542
		},
		"and_chr": {
			"0": 13.282325
		},
		"and_ff": {
			"0": 0.027775
		}
	},
	"total": 97.98029375
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/AO.json
 ** module id = 463
 ** module chunks = 0
 **/